module.exports = __webpack_public_path__ + "static/media/Roboto-Regular.9feb0110.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Roboto-Regular.woff2
// module id = 540
// module chunks = 0